import styled, { css } from 'styled-components'
import { Avatar } from 'antd'

const isPopup = props => props.$variant === 'popup'

export const SharedNotificationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => (isPopup(props) ? '10px 14px' : '14px 20px')};
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  background-color: ${props =>
    isPopup(props) ? (props.isRead ? '#ffffff' : '#f8fafc') : 'transparent'};
  transition: background-color 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${props => (isPopup(props) ? '#f1f5f9' : '#f8fafc')};
  }
`

export const SharedNotificationLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => (isPopup(props) ? '10px' : '14px')};
  flex: 1;
  min-width: 0;
  padding-right: ${props => (isPopup(props) ? 0 : '16px')};
`

export const SharedNotificationAvatar = styled(Avatar)`
  min-width: ${props => (isPopup(props) ? '36px' : '42px')};
  width: ${props => (isPopup(props) ? '36px' : '42px')};
  height: ${props => (isPopup(props) ? '36px' : '42px')};
  line-height: ${props => (isPopup(props) ? '36px' : '42px')};
  font-size: ${props => (isPopup(props) ? '14px' : '16px')};
  font-weight: 600;
  flex-shrink: 0;
  background-color: #5a79ca;

  img {
    object-fit: cover;
  }
`

export const SharedNotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const SharedNotificationTitle = styled.div`
  font-size: ${props => (isPopup(props) ? '13px' : '14px')};
  line-height: ${props => (isPopup(props) ? '18px' : '20px')};
  font-weight: ${props => (props.isRead ? 400 : 600)};
  color: ${props => (props.isRead ? '#64748b' : '#0f172a')};
  word-break: break-word;

  b,
  strong {
    color: #0f172a;
    font-weight: 700;
  }

  ${props =>
    isPopup(props) &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `}
`

export const SharedNotificationDate = styled.span`
  font-size: ${props => (isPopup(props) ? '12px' : '13px')};
  line-height: ${props => (isPopup(props) ? '16px' : '18px')};
  color: ${props => (props.isRead ? '#94a3b8' : '#1890ff')};
  font-weight: ${props => (props.isRead ? 400 : 500)};
  white-space: nowrap;
  display: inline-block;
`

export const SharedNotificationRight = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: ${props => (isPopup(props) ? 0 : '16px')};
  margin-left: ${props => (isPopup(props) ? '8px' : 0)};
`
